export class Enums {
    static CausalType = [
        { id: 1, value: 'Carico magazzino' },
        { id: 2, value: 'Carico acquisti' },
        { id: 3, value: 'Riparazione (carico)' },
        { id: 11, value: 'Scarico inventario' },
        { id: 12, value: 'Scarico vendita' },
        { id: 13, value: 'Riparazione (scarico)' },
        { id: 14, value: 'Scarico addebiti' },
        { id: 15, value: 'Scarico rotture' }
    ];

    static DocState = [
        { id: 1, value: 'Preventivo' },
        { id: 2, value: 'Ordine' },
        { id: 3, value: 'Chiuso' }
    ];

    static MasterType = [
        { id: 1, value: 'Catering' },
        { id: 2, value: 'Food Service Equipment' },
        { id: 3, value: 'Trasporto' },
        { id: 4, value: 'Facchinaggio' }
    ];
}

export class MasterType {
    static Catering = 1;                // Catering
    static FoodServiceEquipment = 2;    // Food Service Equipment
    static Transport = 3;               // Trasporto
    static Porterage = 4;               // Facchinaggio

    static reverseNames = [
        'Catering',
        'Food Service Equipment',
        'Trasporto',
        'Facchinaggio'
    ];
}